import {
  MAX_FILTER_AGE,
  MAX_FILTER_DISTANCE,
  MIN_FILTER_AGE,
  MIN_PHOTO_MIN_NUM,
} from 'Components/Filter/constants';

import type { FiltersState } from './types';

const initialState: FiltersState = {
  filterOptions: {
    distance: MAX_FILTER_DISTANCE,
    hasBio: false,
    isVerified: false,
    maxAge: MAX_FILTER_AGE,
    minAge: MIN_FILTER_AGE,
    minPhotos: MIN_PHOTO_MIN_NUM,
    passions: [],
  },
  isFiltersOpen: false,
};

export default initialState;
